module.exports = __webpack_public_path__ + "static/0026-c34b826ec10f7136b624ce139d6f4b06.png";